import Client from '../axiosClient'
const resource = '/customers';
const resourceInit = 'customers_initialize';

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get(payload) {
    if(payload) {
      return Client.get(`${resource}?page=${payload['page']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);

  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/business/customerRepository.js